// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://idhxhcuomiygywnwohvb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlkaHhoY3VvbWl5Z3l3bndvaHZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY5MjYyODIsImV4cCI6MjA3MjUwMjI4Mn0.w3NJPvsZSNcp4oT_awKFXlKqkE1TVyHW1CKy2EqynMI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});